
import React, { useState } from 'react'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import { useParams } from 'react-router-dom';

const JoinDetails = () => {
    const { slug } = useParams();
   // const [data, setData] = useState({})

    const jobs = [
        {
            id:1,
            title: "Government Teacher",
            details: "Part time, Ibadan"
        },
        {
            id:2,
            title: "Chemistry Teacher",
            details: "Part time, Ibadan"
        },
        {
            id:3,
            title: "English Teacher",
            details: "Part time, Ibadan"
        }
    ]
    const data = jobs.find(job => job.title === slug)
  return (
    <>
    <Nav />
    <section className='pt-[108px] md:pt-[70px] w-[80%] mx-auto md:w-[90%]'>
       <h2 className='font-medium text-4xl text-center mb-10'>{data.title}</h2>
       <p className='text-[#555454] text-base font-normal'>{data.details}</p>
    </section>
    <Footer />
    </>
  )
}

export default JoinDetails